/* Bundle PopUp Manage */
stopIframeVideo = () => {
  
};

function BundlePopUpManage(name,product_id,variant_id,inventory_quantity,qty){
  this.name = name;
  this.container = $("#bp_top"+name);
  this.product_id = product_id;
  this.variant_id = variant_id;
  this.inventory_quantity = inventory_quantity;
  this.qty = qty;
}
BundlePopUpManage.prototype.add= function(){
  //return;
  let add_button = $(".add-on-product-"+this.name+":lt(1)").find(".addintional_product_image");
  $(add_button).trigger('click');
  this.close();
  //Reset Qty
  this.qty = 1;
  $(this.container).find("input[name='quantity']").val(this.qty);
}
BundlePopUpManage.prototype.show=function(){
  $(this.container).show();
  this.initialSlider();
  
  setTimeout(function(){ 
    $(this.container).find(".product-images__slider").flickity('resize');
  }.bind(this), 500);
  
}
BundlePopUpManage.prototype.close=function(){
  $(this.container).hide();
  $('body').css('overflow','auto');
  
  this.stopVideo();
}
BundlePopUpManage.prototype.stopVideo=function(){
  let iframe = $('.media_video')
  iframe.each((index) => {
    iframe[index].contentWindow.postMessage('{"event":"command","func":"' + 'stopVideo' + '","args":""}', '*');
  });
}
BundlePopUpManage.prototype.slierInitialled=function(){
  //Adjust video size
  $(this.container).find(".media_video").each(function(){
    if( $( window ).width()>768 ){
      $(this).css("height","500px");
    }
    else{
      $(this).css("height","300px");
    }
  });
}
BundlePopUpManage.prototype.initialSlider=function(){
  //var that = this;
  $(this.container).find(".product-images__slider").flickity({
    cellSelector: '.product-images__slide',
    wrapAround: true,
    imagesLoaded: true,
    lazyLoad: true,
    pageDots: false,
    arrowShape: { 
      x0: 0,
      x1: 45, y1: 50,
      x2: 50, y2: 50,
      x3: 5
    }
  }).on( 'resize', function() {
    //console.log("test");
    //that.slierInitialled();
  });
  
  $(this.container).find(".product-images__slider").resize();

  
  $(this.container).find(".product-images__thumbs").flickity({
    asNavFor: '.product-images__slider_popup',
    cellSelector: '.product-images__thumbs-slide',
    contain: true,
    pageDots: false,
    prevNextButtons: false
  }).on( 'staticClick.flickity', function( event, pointer, cellElement, cellIndex ) {
    $(this).closest(".bundle_popup_container").find(".product-images__slider").flickity( 'select', cellIndex );
  });

  $(this.container).find(".product-images__slider").on('lazybeforeunveil', function() {
    $(this).closest(".bundle_popup_container").find(".product-images__slider").flickity( 'resize' );
  });
  
  this.slierInitialled();
}
BundlePopUpManage.prototype.QTYIncrement=function(){
  this.qty++;
  $(this.container).find("input[name='quantity']").val(this.qty);
}
BundlePopUpManage.prototype.QTYDecrement=function(){
  this.qty--;
  if( this.qty<1 ) this.qty = 1;
  $(this.container).find("input[name='quantity']").val(this.qty);
}